import { Scale, Shield, BookOpen, Award } from 'lucide-react';
import profileImage from '../assets/pro_aout24_aurore_n07web_(1).jpg';
import profileImageMobile from '../assets/pro_aout24_aurore_n07web_(1)_mobile.jpg';

export default function About() {
  return (
    <section id="about" className="py-24 bg-white dark:bg-warm-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block mb-4 px-5 py-2.5 bg-aurore-light/50 dark:bg-warm-gray-800 rounded-full">
              <span className="text-aurore-dark dark:text-aurore-light text-sm font-medium">À propos</span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
            <div className="text-center md:text-left">
              <h2 className="text-4xl font-bold text-warm-gray-900 dark:text-warm-gray-100 mb-8 leading-tight">
                Pourquoi faire appel à un regard extérieur sur vos questions RH ?
              </h2>

              <p className="text-lg text-warm-gray-700 dark:text-warm-gray-300 mb-7 leading-relaxed-plus">
                Parce que quand on est dans la situation, on ne voit plus toujours les solutions.
                Vous avez besoin de quelqu'un qui comprend le droit social, mais aussi les enjeux humains. Quelqu'un qui ne juge pas, qui écoute d'abord.
              </p>

              <p className="text-lg text-warm-gray-700 dark:text-warm-gray-300 mb-8 leading-relaxed-plus">
                En tant que consultante indépendante, je n'ai aucun lien avec votre entreprise ni vos équipes. Je suis libre de vous dire les choses clairement, sans enjeu politique. Et surtout : je suis de votre côté.
              </p>

              <div className="space-y-5">
                <div className="flex items-start space-x-4">
                  <div className="w-7 h-7 bg-aurore-light/60 dark:bg-warm-gray-700 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2.5 h-2.5 bg-aurore-medium rounded-full"></div>
                  </div>
                  <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed">Accompagnement humain et bienveillant</p>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-7 h-7 bg-aurore-light/60 dark:bg-warm-gray-700 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2.5 h-2.5 bg-aurore-medium rounded-full"></div>
                  </div>
                  <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed">Écoute attentive des situations complexes</p>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-7 h-7 bg-aurore-light/60 dark:bg-warm-gray-700 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2.5 h-2.5 bg-aurore-medium rounded-full"></div>
                  </div>
                  <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed">Mise à jour continue de mes connaissances pour mieux vous servir</p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-br from-aurore-medium/30 via-aurore-light/50 to-aurore-pale dark:from-aurore-medium/20 dark:via-aurore-dark/30 dark:to-warm-gray-800 rounded-3xl blur-xl opacity-60 group-hover:opacity-80 transition duration-700"></div>

                <div className="relative bg-white dark:bg-warm-gray-800 rounded-3xl p-8 shadow-md group-hover:shadow-lg transition-shadow duration-500">
                  <div className="relative">
                    <div className="w-full aspect-square rounded-2xl overflow-hidden mb-6 bg-gradient-to-br from-aurore-light/40 to-aurore-pale dark:from-warm-gray-700 dark:to-warm-gray-800">
                      <img
                        src={profileImage}
                        srcSet={`${profileImageMobile} 400w, ${profileImage} 800w`}
                        sizes="(max-width: 768px) 100vw, 50vw"
                        alt="Aurore - Consultante en Droit Public & RH"
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>

                    <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-aurore-dark to-aurore-medium px-8 py-3 rounded-full shadow-md">
                      <h3 className="text-xl font-bold text-white text-center">Aurore</h3>
                    </div>
                  </div>

                  <div className="mt-10 mb-6">
                    <p className="text-aurore-dark dark:text-aurore-light text-center font-medium text-lg">Consultante RH & Droit social</p>
                  </div>

                  <div className="space-y-4 text-sm">
                    <div className="flex items-center space-x-3 bg-aurore-light/20 dark:bg-warm-gray-700/50 p-4 rounded-2xl hover:bg-aurore-light/40 dark:hover:bg-warm-gray-700 transition-all duration-300">
                      <Award className="w-5 h-5 text-aurore-dark dark:text-aurore-light flex-shrink-0" />
                      <span className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed">Master management et maîtrise en droit public</span>
                    </div>
                    <div className="flex items-center space-x-3 bg-aurore-light/20 dark:bg-warm-gray-700/50 p-4 rounded-2xl hover:bg-aurore-light/40 dark:hover:bg-warm-gray-700 transition-all duration-300">
                      <BookOpen className="w-5 h-5 text-aurore-dark dark:text-aurore-light flex-shrink-0" />
                      <span className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed">Accompagnement RH des entreprises et particuliers</span>
                    </div>
                    <div className="flex items-center space-x-3 bg-aurore-light/20 dark:bg-warm-gray-700/50 p-4 rounded-2xl hover:bg-aurore-light/40 dark:hover:bg-warm-gray-700 transition-all duration-300">
                      <Shield className="w-5 h-5 text-aurore-dark dark:text-aurore-light flex-shrink-0" />
                      <span className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed">Soutien dans les pratiques RH et le recrutement</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-aurore-pale to-aurore-light/30 dark:from-warm-gray-800 dark:to-warm-gray-800 rounded-3xl p-10 md:p-14">
            <h3 className="text-3xl font-bold text-warm-gray-900 dark:text-warm-gray-100 mb-10 text-center leading-tight">
              Ce que vous gagnez à travailler avec une consultante indépendante
            </h3>

            <div className="grid md:grid-cols-3 gap-10">
              <div className="text-center">
                <div className="w-20 h-20 bg-white dark:bg-warm-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm">
                  <Shield className="w-9 h-9 text-aurore-dark dark:text-aurore-light" />
                </div>
                <h4 className="text-xl font-semibold text-warm-gray-900 dark:text-warm-gray-100 mb-3">Zéro conflit d'intérêts</h4>
                <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed-plus">
                  Je ne dépends de personne dans votre structure. Je peux vous dire les choses franchement, en toute confidentialité.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-white dark:bg-warm-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm">
                  <BookOpen className="w-9 h-9 text-aurore-dark dark:text-aurore-light" />
                </div>
                <h4 className="text-xl font-semibold text-warm-gray-900 dark:text-warm-gray-100 mb-3">Toujours à jour</h4>
                <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed-plus">
                  Le droit social évolue sans cesse. Je me forme en permanence pour vous éviter les mauvaises surprises.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-white dark:bg-warm-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm">
                  <Scale className="w-9 h-9 text-aurore-dark dark:text-aurore-light" />
                </div>
                <h4 className="text-xl font-semibold text-warm-gray-900 dark:text-warm-gray-100 mb-3">Vraiment sur mesure</h4>
                <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed-plus">
                  Votre contexte est unique. Je ne plaque pas de solution toute faite, je construis avec vous.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
